import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { ICON_SIZE_OPTIONS } from '../../utils/constants';
import { transformIconProps } from '../../utils/icons';
import { deprecated } from '../../utils/proptypes';
var IconUiInfoFilled = function IconUiInfoFilled(_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? 'currentColor' : _ref$fillColor,
    _ref$strokeColor = _ref.strokeColor,
    strokeColor = _ref$strokeColor === void 0 ? '#fff' : _ref$strokeColor,
    props = _objectWithoutProperties(_ref, ["disabled", "fillColor", "strokeColor"]);
  return disabled ? jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16",
    height: "16",
    fill: "none"
  }, transformIconProps(props)), jsx("path", {
    fill: "#BCC3CA",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
  }), jsx("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 11.25v-4a.667.667 0 0 0-.667-.667h-.667M6.722 11.25H9.39"
  }), jsx("path", {
    stroke: "#fff",
    fill: "#fff",
    d: "M7.833 4.833a.167.167 0 1 1 0-.333M7.833 4.833a.167.167 0 1 0 0-.333"
  })) : jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    viewBox: "0 0 16 16"
  }, transformIconProps(props)), jsx("path", {
    fill: fillColor,
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
  }), jsx("path", {
    stroke: strokeColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 11.25v-4a.667.667 0 0 0-.667-.667h-.667"
  }), jsx("path", {
    stroke: strokeColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.722 11.25H9.39"
  }), jsx("path", {
    stroke: "#fff",
    d: "M7.833 4.833a.167.167 0 1 1 0-.333"
  }), jsx("path", {
    stroke: "#fff",
    d: "M7.833 4.833a.167.167 0 1 0 0-.333"
  }));
};
export { IconUiInfoFilled };